import React from 'react';
import { motion } from 'framer-motion';

const Certifications = ({ certifications }) => {
  return (
    <section className="min-h-screen py-20 px-6" data-testid="certifications-section">
      <div className="max-w-6xl mx-auto">
        <motion.h2
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-5xl font-bold text-pure-white mb-12"
        >
          Certifications
        </motion.h2>

        {certifications.length === 0 ? (
          <p className="text-gray-400 text-lg">No certifications found matching your search.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {certifications.map((cert, index) => (
              <motion.div
                key={cert.id}
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                whileHover={{ scale: 1.05, rotate: 2 }}
                className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-apple-blue transition-all duration-300"
                data-testid={`cert-item-${cert.id}`}
              >
                {cert.imageUrl ? (
                  <div className="w-full h-48 bg-gradient-to-br from-apple-blue/20 to-purple-600/20 rounded-xl mb-4 flex items-center justify-center overflow-hidden">
                    <img
                      src={cert.imageUrl}
                      alt={cert.title}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `<div class="text-6xl">🏆</div>`;
                      }}
                    />
                  </div>
                ) : (
                  <div className="w-full h-48 bg-gradient-to-br from-apple-blue/20 to-purple-600/20 rounded-xl mb-4 flex items-center justify-center">
                    <span className="text-6xl">🏆</span>
                  </div>
                )}
                <h3 className="text-xl font-semibold text-pure-white mb-2">
                  {cert.title}
                </h3>
                <p className="text-gray-400 text-sm mb-2">{cert.issuer}</p>
                <p className="text-gray-500 text-xs">{cert.date}</p>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Certifications;
